var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2606 1246 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #f8981d;\n      }\n\n      .cls-4 {\n        fill: #d98924;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    transform: "translate(2558 1165)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60,
    cy: 60,
    id: "Ellipse_61",
    r: 60,
    transform: "translate(48 81)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    transform: "translate(-101.356 -113.223)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2303.133,186.866c1.258-.715.734-5.719,6.817-7.046s7.97,3.778,7.97,3.778v6.433s-14.525.332-21.6,5.106-6.711,13.99-6.711,13.99-1.888,11.131,10.382,14.194,20.344-6.229,20.344-6.229a29.138,29.138,0,0,0,3.776,4.8c1.783,1.634,2.2,1.838,3.356,1.736s9.228-6.842,9.124-7.965-4.4-7.557-4.4-7.557V181.658s-1.573-6.408-6.4-9.5-12.9-2.859-12.9-2.859a22.762,22.762,0,0,0-16.255,5.106c-7.236,6.229-5.453,11.539-5.034,11.744S2301.875,187.581,2303.133,186.866Z",
    id: "Path_172",
    transform: "translate(-2102.457 49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2317.458,197.4s-7.472-.128-11.011,2.553-3.146,7.863-3.146,7.863,1.259,6.331,7.131,5.31,7.026-9.191,7.026-9.191Z",
    id: "Path_173",
    transform: "translate(-2101.786 49.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2279.765,223.1s12.9,9.7,29.573,11.029,30.622-6.638,30.622-6.638.944,0,1.258.511a2.4,2.4,0,0,1,0,1.532s-10.8,11.744-30.937,10.824-31.356-15.726-31.356-15.726-.76-1.074-.524-1.532S2279.765,223.1,2279.765,223.1Z",
    id: "Path_174",
    transform: "translate(-2103 50.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2331.606,225.571s2.989-.306,5.243-.306a21.08,21.08,0,0,1,3.775.306s.76.306.42,2.655-2.438,6.28-1.783,6.74,3.094-1.915,4.4-4.9,1.258-6.536.839-7.046-3.88-1.123-7.236-.715S2330.767,225.162,2331.606,225.571Z",
    id: "Path_175",
    transform: "translate(-2100.413 50.121)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonStore);
export default __webpack_public_path__ + "static/media/amazonStore.3c44f9ee.svg";
export { ForwardRef as ReactComponent };